import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Button,
  Grid2,
  CircularProgress,
} from "@mui/material";
import events2 from "../../assets/images/events_2.png";
import locationSmall from "../../assets/images/location-small.svg";
import userSmall from "../../assets/images/user-small.svg";
import dateSmall from "../../assets/images/date-small.svg";
import { useNavigate, useParams } from "react-router-dom";
import buypriceSmall from "../../assets/images/buyprice-small.svg";
import useRequests from "../../utils/useRequests";
import { format } from "date-fns";
import Snackbars from "../../utils/Snackbars";


const Sellticketconfirmation = () => {
  const { r_id } = useParams();
  const [loading, setLoading] = useState(true);
  const { getRequest } = useRequests();

  const navigate = useNavigate();
  const handleBuyTicket = () => {
    navigate("/dashboard");
  };

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  });
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: "",
        message: "",
      }));
    }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
  };

  const [detail, setDetail] = useState({
    type: "",
    day_pass: "",
    quantity: "",
    resale_quantity: "",
    resold_quantity: "",
    name: "",
    address: "",
    start_datetime: "",
    end_datetime: "",
    time: "",
    banner: "",
    event_ticket_date: "",
    purchase_price: "",
    resale_price: "",
  });

  const fetchResaleTicketDetails = async () => {
    setLoading(true);
    try {
      const response = await getRequest(`resell-ticket-details/${r_id}`);
      if (response && response.code === 200) {
        const data = response.data;
        const calculatedMaxDays = calculateMaxEventDays(data.start_datetime, data.end_datetime);
        setMaxEventDays(calculatedMaxDays);
        setDetail({
          e_id: data.e_id,
          type: data.type,
          day_pass: data.day_pass,
          quantity: data.quantity,
          resale_quantity: data.resale_quantity,
          resold_quantity: data.resold_quantity,
          name: data.name,
          address: data.address,
          start_datetime: data.start_datetime,
          end_datetime: data.end_datetime,
          time: data.start_time + " - " + data.end_time,
          banner: data.banner,
          event_ticket_date: data.event_ticket_date,
          purchase_price: data.purchase_price,
          resale_price: data.resale_price,
          ticket_time: data.time
        });
        console.log("banner", data.banner);
      } else {
        setAlertData({
          variant: "error",
          message: response.message || "Failed to fetch ticket details",
        });
      }
    } catch (error) {
      setAlertData({ variant: "error", message: "Something went wrong!" });
    }
    setLoading(false);
    resetAlertData();
  };


    const [maxEventDays, setMaxEventDays] = useState(1);
    const calculateMaxEventDays = (startDate, endDate) => {
        if (!startDate || !endDate) return 1;
        
        const start = new Date(startDate);
        const end = new Date(endDate);
        const diffTime = Math.abs(end - start);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 to include both start and end days
        
        return Math.min(diffDays, 10); // Max 10 days
    };


  useEffect(() => {
    fetchResaleTicketDetails();
  }, [r_id]);

  const formatEventDate = (start, end, time, ticketDate) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffInMs = endDate - startDate; // Difference in milliseconds
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24); // Convert to days
    const day = `${diffInDays + 1}`.toLowerCase();

    const startDay = format(startDate, "dd");
    const endDay = format(endDate, "dd");
    const endmonth = format(endDate, "MMMM");
    const startmonth = format(startDate, "MMMM");
    const year = format(startDate, "yyyy");
    let daysCount = day;
    if (day > 1) {
      daysCount = "10";
    }

    const ticket_date = new Date(ticketDate);
    const ticketDay = format(ticket_date, "dd");

    if (startDay == endDay) {
      return {
        formattedDate: `${startDay} ${startmonth} ${year}`,
        daysCount: `${daysCount} Day's Event`,
        time,
        ticketFormatedDate: `${ticketDay} ${startmonth} ${year}`,
      };
    }

    return {
      formattedDate: `${startDay} ${startmonth} - ${endDay} ${endmonth} ${year}`,
      daysCount: `${daysCount} Day's Event`,
      time,
      ticketFormatedDate: `${ticketDay} ${startmonth} ${year}`,
    };
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          minHeight: "300px",
        }}
      >
        <CircularProgress color="primary" />
        <p>Loading ...</p>
      </Box>
    );
  }
  if (!detail) return <Typography>No ticket details found.</Typography>;
  const { formattedDate, daysCount, time, ticketFormatedDate } =
    formatEventDate(
      detail.start_datetime,
      detail.end_datetime,
      detail.time,
      detail.event_ticket_date
    );

    const getSelectedTicketTime = () => {
        if (!detail) return null;
        if (detail.ticket_time) return detail.ticket_time;
        return null;
    };

  return (
    <Box sx={{ flexGrow: 1 }}>
      {AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "calc(98vh - 33px)",
        }}
        className="celebration-bg"
      >
        <Box sx={{ width: 500, padding: "30px 15px", borderRadius: 2 }}>
          <Typography variant="h4" className="title congratulation">
            CONGRATULATIONS
          </Typography>
          <Typography variant="h4" className="title confirm resell-confrim">
            Your {detail.e_id == "8"? "invitation":"ticket"} is now listed for resale in the secondary market.
          </Typography>
          <div container spacing={2}>
            <div item xs={12}>
              <Box className="events-box">
                <Card
                  sx={{
                    borderRadius: "10px",
                    padding: "15px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                  }}
                >
                  <div className="position-relative radius-img-box">
                    <CardMedia
                      component="img"
                      height="185"
                      image={detail.banner}
                      alt={detail.name}
                    />
                  </div>
                  <CardContent style={{ padding: "9px 5px" }}>
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{
                        color: "#6638A2",
                        marginTop: "5px",
                        fontSize: "21px",
                        marginBottom: "10px",
                        lineHeight: "32px",
                        fontWeight: "500",
                      }}
                    >
                      {detail.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "11px",
                        fontSize: "16px",
                        color: "#341439",
                      }}
                    >
                      <img src={locationSmall} alt="" className="small-svg" />
                      {`${detail.type} Ticket, ${detail.day_pass} Day Pass, ${detail.resale_quantity} Person`}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "11px",
                        fontSize: "16px",
                        color: "#341439",
                      }}
                    >
                      <img src={dateSmall} alt="" className="small-svg" />
                      {detail.day_pass == 1
                        ? ticketFormatedDate
                        : formattedDate}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', marginTop: '8px', fontSize: "16px", color: "#341439" }}>
                        <img src={dateSmall} alt='' className='small-svg' />
                        {getSelectedTicketTime() || time}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "11px",
                        fontSize: "16px",
                        color: "#341439",
                      }}
                    >
                      <img
                        src={buypriceSmall}
                        alt=""
                        className="small-svg"
                        style={{ width: "16px", marginLeft: "1px" }}
                      />
                      {` Buying Price ₹${
                        detail.resale_quantity *
                        (Number(detail.purchase_price) /
                          (Number(detail.quantity) +
                            Number(detail.resold_quantity)))
                      }`}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "11px",
                        fontSize: "16px",
                        color: "#341439",
                      }}
                    >
                      <img src={userSmall} alt="" className="small-svg" />
                      {detail.address}
                    </Typography>
                    <Typography className="Sell-title">
                      Ticket Selling Price
                    </Typography>
                    <Typography className="Sell-price">
                      ₹{detail.resale_price}
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            </div>
            <Grid2 className="button-bottom fullWidth mt-3" fullWidth>
              <Button
                className="btn-common"
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleBuyTicket}
              >
                Go TO Events Page
              </Button>
            </Grid2>
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default Sellticketconfirmation;
